import { z } from 'zod';

/** Tipos de reporte apresentados para quem usa o app. */
export const supportKindSchema = z.enum(['bug', 'suggestion', 'question']);
export type SupportKind = z.infer<typeof supportKindSchema>;

/** Estados internos usados na triagem administrativa. */
export const supportTicketStatusSchema = z.enum(['pending', 'in_progress', 'completed']);
export type SupportTicketStatus = z.infer<typeof supportTicketStatusSchema>;

/** Campos recebidos ao criar um reporte. O usuário vem sempre da sessão. */
export const createSupportTicketFieldsSchema = z.object({
  kind: supportKindSchema,
  pagePath: z.string().trim().startsWith('/').max(500),
  pageLabel: z.string().trim().min(1).max(120),
  happenedDetails: z.string().trim().min(40, 'Descreva o que aconteceu com pelo menos 40 caracteres.').max(2_000),
  reproductionDetails: z
    .string()
    .trim()
    .min(40, 'Explique como repetir o problema com pelo menos 40 caracteres.')
    .max(2_000),
});
export type CreateSupportTicketFields = z.infer<typeof createSupportTicketFieldsSchema>;

/** O status só pode ser alterado pela rota administrativa. */
export const updateSupportTicketBodySchema = z.object({
  status: supportTicketStatusSchema,
});
export type UpdateSupportTicketBody = z.infer<typeof updateSupportTicketBodySchema>;

export const supportTicketSchema = z.object({
  id: z.string(),
  kind: supportKindSchema,
  status: supportTicketStatusSchema,
  pagePath: z.string(),
  pageLabel: z.string(),
  happenedDetails: z.string(),
  reproductionDetails: z.string(),
  createdAt: z.string(),
  startedAt: z.string().nullable(),
  completedAt: z.string().nullable(),
  hasScreenshot: z.boolean(),
  reporter: z.object({
    id: z.string(),
    name: z.string(),
    email: z.string().email(),
  }),
});
export type SupportTicket = z.infer<typeof supportTicketSchema>;

export const supportTicketsResponseSchema = z.object({
  tickets: z.array(supportTicketSchema),
  nextCursor: z.string().nullable(),
});
export type SupportTicketsResponse = z.infer<typeof supportTicketsResponseSchema>;

export const createSupportTicketResponseSchema = z.object({
  id: z.string(),
  createdAt: z.string(),
});
export type CreateSupportTicketResponse = z.infer<typeof createSupportTicketResponseSchema>;
